// js
import React, { Component } from 'react';
import classnames from 'classnames';
import { Link } from 'react-router';
import { compact } from 'lodash';
import PropTypes from 'prop-types';
// css
import '../../styles/components/common/Button.scss';


class Button extends Component {
  getClassNames() {
    return classnames({
      'button': true,
      'button-primary': this.props.primary,
      'button-disabled': this.props.disabled || this.props.loading
    });
  }

  render() {
    const { to, href, label, onClick, disabled, loading, loadingLabel, iconSrc } = this.props;
    const icon =
      iconSrc ?
      (
        <img
          key='image'
          className='button-icon'
          src={iconSrc}
          alt={label}
        />
      ) :
      null;

    const contents = compact([icon, label]);

    if (loading) {
      return (
        <a className={this.getClassNames()}>
          {loadingLabel}
        </a>
      );
    } else if (to) {
      return (
        <Link
          className={this.getClassNames()}
          to={to}
        >
          {contents}
        </Link>
      );
    } else if (href) {
      // used for links outside this application
      return (
        <a
          className={this.getClassNames()}
          href={href}
        >
          {contents}
        </a>
      );
    } else {
      return (
        <a
          className={this.getClassNames()}
          onClick={onClick}
          disabled={disabled || loading}
        >
          {contents}
        </a>
      );
    }
  }
}

Button.defaultProps = {
  loadingLabel: 'Loading…'
};

Button.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  loadingLabel: PropTypes.string,
  primary: PropTypes.bool,
  to: PropTypes.string,
  href: PropTypes.string,
  iconSrc: PropTypes.string
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/common/Button.js